import GlobalOverride from "views/logic/search/GlobalOverride";
import { runStartJob, runPollJob, runCancelJob } from "views/stores/SearchJobs";
import SearchResult from "views/logic/SearchResult";
const delay = (ms) => new Promise((resolve) => {
  setTimeout(resolve, ms);
});
export const buildSearchExecutionState = (searchTypesToSearch, executionStateParam, keepQueries = []) => {
  var _a;
  const globalOverride = ((_a = executionStateParam.globalOverride) != null ? _a : GlobalOverride.empty()).toBuilder().keepQueries(keepQueries).build();
  let executionStateBuilder = executionStateParam.toBuilder().globalOverride(globalOverride);
  if (searchTypesToSearch) {
    const keepSearchTypes = [...globalOverride.keepSearchTypes || [], ...searchTypesToSearch];
    const newGlobalOverride = globalOverride.toBuilder().keepSearchTypes(keepSearchTypes).build();
    executionStateBuilder = executionStateBuilder.globalOverride(newGlobalOverride);
  }
  return executionStateBuilder.build();
};
export const startJob = async (search, searchTypesToSearch, executionStateParam, keepQueries = []) => {
  const executionState = buildSearchExecutionState(searchTypesToSearch, executionStateParam, keepQueries);
  return runStartJob(search, executionState).then((res) => ({ asyncSearchId: res.id, nodeId: res.executing_node }));
};
const getDelayTime = (depth = 1) => {
  const curDepth = Math.min(Math.max(1, depth), 100);
  return Math.ceil(curDepth / 10) * 250;
};
export const pollJob = ({
  jobIds,
  result,
  depth = 1,
  page,
  perPage,
  stopPolling
}) => new Promise((resolve) => {
  var _a, _b, _c;
  if ((stopPolling == null ? void 0 : stopPolling((_a = result == null ? void 0 : result.progress) != null ? _a : 0)) || ((_b = result == null ? void 0 : result.execution) == null ? void 0 : _b.done) || ((_c = result == null ? void 0 : result.execution) == null ? void 0 : _c.cancelled)) {
    resolve(result);
  } else {
    delay(getDelayTime(depth)).then(() => {
      resolve(
        runPollJob({ jobIds, page, perPage }).then(
          (res) => pollJob({ jobIds, result: res, depth: depth + 1, page, perPage, stopPolling })
        )
      );
    });
  }
});
export const executeJobResult = async ({
  jobIds: { asyncSearchId, nodeId },
  widgetMapping,
  page,
  perPage,
  stopPolling
}) => pollJob({
  jobIds: { asyncSearchId, nodeId },
  result: null,
  depth: 1,
  page,
  perPage,
  stopPolling
}).then((result) => ({
  result: new SearchResult(result),
  widgetMapping,
  jobIds: { asyncSearchId, nodeId }
}));
export const cancelJob = (jobIds) => runCancelJob(jobIds);
export default executeJobResult;
